import React from 'react';
import Pinpoints from '../components/Pinpoints';

export default function CondoCleaning() {
  return (
    <main className='am-container condo-cleaning-page'>
      <section className='cc-hero'>
        <div className='cc-content'>
          <h1 className='cc-title'>Condo Cleaning Services</h1>

          <p className='cc-lead'>
            AM Facilities offers professional condo cleaning services for a spotless, refreshed living space. Our team
            handles dusting, vacuuming, kitchen sanitization, and bathroom cleaning.
          </p>

          <p className='cc-lead'>
            Whether you need a one-time deep clean or regular maintenance, we ensure a pristine home without the hassle.
          </p>

          <h2 className='cc-sub'>Why Choose Our Condo Cleaning Services?</h2>

          <Pinpoints
            className='cc-list'
            iconClass='cc-badge'
            itemTag='span'
            items={[
              'Experienced and insured cleaning professionals',
              'Customized cleaning plans tailored to your needs',
              'Eco-friendly and non-toxic cleaning products',
              'Flexible scheduling options: weekly, bi-weekly, or monthly',
              'Guaranteed satisfaction with high-quality standards',
            ]}
          />

          <p className='cc-cta-lead'>
            Enjoy a pristine, stress-free home with AM Facilities.
            <br />
            Contact us now for a free quote!
          </p>

          <div className='cc-actions'>
            <a
              className='am-cta am-cta-primary'
              href='https://app.zenmaid.com/book/a-m-facilities'
              target='_blank'
              rel='noreferrer noopener'
            >
              Schedule Your Condo Cleaning Today!
            </a>
          </div>

          <div className='cc-back'>
            <a href='/#services' className='cc-back-link'>
              Click here and go back to the main services.
            </a>
          </div>
        </div>

        <aside className='cc-aside'>
          <img src='/assets/condo_cleaning.avif' alt='Condo cleaning services' />
        </aside>
      </section>
    </main>
  );
}
